/**
 * Internal session detection.
 *
 * Sessions started by staff (signed in as superadmin / admin / org_owner /
 * salesperson when they linked the kiosk) carry `initiated_by_role` on the
 * sessions/{id} doc, stamped forward-only by the cloud's linkKioskSession
 * and copied onto the session by the kiosk. These are excluded from:
 *   - the Sessions UI for non-superadmin viewers
 *   - sales / payout / revenue math everywhere
 *
 * Superadmins can opt-in to seeing them in the Sessions UI via a localStorage
 * toggle (see SHOW_INTERNAL_STORAGE_KEY). The toggle never affects money math.
 *
 * Legacy sessions written before this field existed have no initiated_by_role
 * and are treated as customer sessions — historical payout reports already
 * counted them that way, so this is the safe choice for backwards
 * consistency.
 */

export const INTERNAL_ROLES = ['superadmin', 'admin', 'org_owner', 'salesperson', 'affiliate', 'social_media'];

export const SHOW_INTERNAL_STORAGE_KEY = 'socialsnap-show-internal-sessions';

export const isInternalSession = (session) => {
  if (!session) return false;
  // Works on either a plain object or a Firestore QueryDocumentSnapshot.
  const role = typeof session.data === 'function'
    ? session.data()?.initiated_by_role
    : session.initiated_by_role;
  return INTERNAL_ROLES.includes(role);
};

export const readShowInternalPref = () => {
  try {
    return window.localStorage?.getItem(SHOW_INTERNAL_STORAGE_KEY) === '1';
  } catch (_) {
    return false;
  }
};

export const writeShowInternalPref = (value) => {
  try {
    window.localStorage?.setItem(SHOW_INTERNAL_STORAGE_KEY, value ? '1' : '0');
  } catch (_) { /* noop */ }
};
